import { useQuery } from '@tanstack/react-query';
import { vacation } from '@/utils/api';

export function useVacationRequests(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['vacation', params],
    queryFn: () => vacation.getAll(params).then((r) => r.data),
  });
}

export function useVacationSummary(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['vacation', 'summary', params],
    queryFn: () => vacation.getSummary(params).then((r) => r.data),
  });
}

export function useVacationStats(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['vacation', 'stats', params],
    queryFn: () => vacation.getStats(params).then((r) => r.data),
  });
}
